import { render, staticRenderFns } from "./p_esg023.vue?vue&type=template&id=1d196aa9&scoped=true&"
import script from "./p_esg023.vue?vue&type=script&lang=js&"
export * from "./p_esg023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d196aa9",
  null
  
)

export default component.exports